// https://github.com/posva/unplugin-vue-router
import { createRouter, createWebHashHistory } from 'vue-router/auto'

// console.log(routes);
const router = createRouter({
  history: createWebHashHistory()
});

router.beforeEach((to, from, next) => {
  ((document as any).title = to.meta.title || ''); // 设置默认标题
  next()
});

router.onError((error, to) => {
  console.log(error.message);
  if (
    ['Failed to fetch dynamically imported module', 'Importing a module script failed'].includes(error.message)
  ) {
    if (!to?.fullPath) {
      window.location.reload();
    } else {
      window.location = to.fullPath;
    }
  }
})

export default router;
